
// ORIGNAL LIGHT
import PaletteProto from "../../../core/gd/skin/skin-palette/palette-proto";
import {SkinGrayColorPalette} from "../../../core/gd/skin/skin-palette/@type";

const LIGHT_CONTRAST_1: SkinGrayColorPalette = {
    'palette-gray-0': '#FAFBFC',
    'palette-gray-1': '#FAFBFC',
    'palette-gray-2': '#FAFBFC',
    'palette-gray-2-value': '#FAFBFC',
    'palette-gray-3': '#F7F8FA',
    'palette-gray-4': '#ECEFF3',
    'palette-gray-5': '#ECEFF3',
    'palette-gray-6': '#E6EBEF',
    'palette-gray-7': '#DADDE1',
    'palette-gray-8': '#CDD2D7',
    'palette-gray-9': '#7E8B98',
    'palette-gray-10': '#58697A',
    'palette-gray-11': '#4E5D6B'
}

const LIGHT_CONTRAST_2 = {
    'palette-gray-0': '#F8F9FA',
    'palette-gray-1': '#F8F9FA',
    'palette-gray-2': '#F8F9FA',
    'palette-gray-2-value': '#FAFBFC',
    'palette-gray-3': '#F4F5F7',
    'palette-gray-4': '#E9ECF0',
    'palette-gray-5': '#E9ECF0',
    'palette-gray-6': '#E4E9ED',
    'palette-gray-7': '#D7DADE',
    'palette-gray-8': '#CACFD4',
    'palette-gray-9': '#7E8B98',
    'palette-gray-10': '#58697A',
    'palette-gray-11': '#4E5D6B'
}

// ORIGINAL CONTRAST !
const LIGHT_CONTRAST_3 = {
    'palette-gray-0': '#F5F6F7',
    'palette-gray-1': '#F5F6F7',
    'palette-gray-2': '#F5F6F7',
    'palette-gray-2-value': '#FAFBFC',
    'palette-gray-3': '#F2F4F5',
    'palette-gray-4': '#E6EAED',
    'palette-gray-5': '#E6EAED',
    'palette-gray-6': '#E2E6EB',
    'palette-gray-7': '#D3D7DB',
    'palette-gray-8': '#C5CBD1',
    'palette-gray-9': '#7E8B98',
    'palette-gray-10': '#58697A',
    'palette-gray-11': '#4E5D6B',
}

// MORE CONTRAST
const LIGHT_CONTRAST_4 = {
    'palette-gray-0': '#F3F4F5',
    'palette-gray-1': '#F3F4F5',
    'palette-gray-2': '#F3F4F5',
    'palette-gray-2-value': '#FAFBFC',
    'palette-gray-3': '#F0F1F2',
    'palette-gray-4': '#E4E8EB',
    'palette-gray-5': '#E4E7EB',
    'palette-gray-6': '#DFE3E8',
    'palette-gray-7': '#D0D4D9',
    'palette-gray-8': '#C0C6CF',
    'palette-gray-9': '#7E8B98',
    'palette-gray-10': '#58697A',
    'palette-gray-11': '#4E5D6B',
}

// MORE CONTRAST
const LIGHT_CONTRAST_5 = {
    'palette-gray-0': '#F0F2F5',
    'palette-gray-1': '#F0F2F5',
    'palette-gray-2': '#F0F2F5',
    'palette-gray-2-value': '#FAFBFC',
    'palette-gray-3': '#EBEEF2',
    'palette-gray-4': '#E0E5EB',
    'palette-gray-5': '#DEE3E8',
    'palette-gray-6': '#DBE0E5',
    'palette-gray-7': '#CFD1D6',
    'palette-gray-8': '#BAC2C9',
    'palette-gray-9': '#7E8B98',
    'palette-gray-10': '#58697A',
    'palette-gray-11': '#4E5D6B',
}

// This is dark blue
const DARK_CONTRAST_1 = {
    'palette-gray-0': '#1A222C',
    'palette-gray-1': '#1C2631',
    'palette-gray-2': '#1C2631',
    'palette-gray-2-value': '#1C2631',
    'palette-gray-3': '#212A35',
    'palette-gray-4': '#27313B',
    'palette-gray-5': '#3C434C',
    'palette-gray-6': '#484E56',
    'palette-gray-7': '#535961',
    'palette-gray-8': '#5F646B',
    'palette-gray-9': '#7E8B98',
    'palette-gray-10': '#9A9FA3',
    'palette-gray-11': '#ABAFB3'
}

// This is Black (telegram) theme
const DARK_CONTRAST_2 = {
    'palette-gray-0': '#1A232B',
    'palette-gray-1': '#1A232B',
    'palette-gray-2': '#1E2831',
    'palette-gray-2-value': '#1A232B',
    'palette-gray-3': '#232C35',
    'palette-gray-4': '#2E353C',
    'palette-gray-5': '#3A4147',
    'palette-gray-6': '#454C51',
    'palette-gray-7': '#51575C',
    'palette-gray-8': '#5D6267',
    'palette-gray-9': '#7E8B98',
    'palette-gray-10': '#9A9FA3',
    'palette-gray-11': '#ABAFB3'
}

const DEFAULT_PALETTE = 'light-1'

const debug = false
// const debug = "GrayPalette"

export default class GrayPalette_GoodDay extends PaletteProto {

    constructor(currentPalette = DEFAULT_PALETTE) {

        super(currentPalette, DEFAULT_PALETTE)

        this.palettes = {
            'light-1'   : LIGHT_CONTRAST_1,
            'light-2'   : LIGHT_CONTRAST_2,
            'light-3'   : LIGHT_CONTRAST_3,
            'light-4'   : LIGHT_CONTRAST_4,
            'light-5'   : LIGHT_CONTRAST_5,
            'dark-1'    : DARK_CONTRAST_1,
            'dark-2'    : DARK_CONTRAST_2,
        }

        this.setPalette(this.currentPalette)


        debug && console.log(debug, 'constructor', this.palettes[this.currentPalette])
    }

    applyDOMCssVariables() {

        // New. This is creating a style tag and setting root variables in it.
        const STYLE_ID = 'dynamic-gray-palette-vars'

        const palette = this.palettes[this.currentPalette]

        let styleTag = document.getElementById(STYLE_ID)

        if (!styleTag) {
            styleTag = document.createElement('style')
            styleTag.id = STYLE_ID
            document.head.appendChild(styleTag)
        }

        const cssVars = Object.entries(palette)
            .map(([key, value]) => `--${key}: ${value};`)
            .join('\n')

        styleTag.textContent = `
            html:root {
                ${cssVars}
            }
        `

        // Old way
        // const palette = this.palettes[this.currentPalette]
        // const root = document.querySelector(':root');
        //
        // for (let i=0; i<=11; i++) {
        //     // @ts-ignore
        //     root.style.setProperty('--palette-gray-'+i, palette[`palette-gray-${i}`])
        // }
    }

    lightPalettes() {
        return [
            'light-1',
            'light-2',
            'light-3',
            'light-4',
            'light-5',
        ]
    }

    getColorHEX(index:number) {
        return this.palettes[this.currentPalette] ? this.palettes[this.currentPalette][`palette-gray-${index}`] : '#000000'
    }

    // darkPalettes() {
    //     return [
    //         'dark-1',
    //         'dark-2'
    //     ]
    // }
}
